// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat&display=swap);"]);
// Module
exports.push([module.id, ".card-text[data-v-e4065668]{font-family:\"Montserrat\",sans-serif}.card-header[data-v-e4065668]{background-color:#a5d6a7}.card-background-header[data-v-e4065668]{background-color:#b2ebf2}.card-background[data-v-e4065668]{background-color:#e5ffff}", ""]);
// Exports
module.exports = exports;
